<template>
    <div></div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";

export default {
    name: "ApiAjax",
    props: ['field', 'formValues', 'stageId'],

    computed: {
        ...mapState({proceduresStore: state => state.procedures}),
        ...mapGetters('procedures', [/*'procedureDataForm', 'form', */ 'procedureData' /*, 'procedureMeta'*/])
    },

    watch:{
        '$store.state.procedures.apiAjaxContent'(){
            if (this.proceduresStore.apiAjaxContent !== null && this.proceduresStore.apiAjaxFieldId === this.field.id){
                this.setApiAjaxResultToFormValues()
            }
        }
    },

    created() {
        this.$root.$once(`fire_${this.field.id}`, this.requestApiAjax)
    },

    beforeDestroy() {
        this.$root.$off(`fire_${this.field.id}`)
    },

    methods: {
        ...mapActions('procedures', ['getApiAjaxContent']),

        requestApiAjax(){

            let request = {
                fieldId: this.field.id,
                url: this.getUrl(this.field.extra.url),
                etapa: this.field.stageId,
                service_type: this.field.extra.request,
                prefix: this.field.extra.prefijo,
                params: JSON.stringify(this.getParams())
            }

            this.getApiAjaxContent(request)
            this.$root.$once(`fire_${this.field.id}`, this.requestApiAjax)
        },

        getParams(){
            let params = {'campos': this.field.extra.campos, 'valores': []}


            this.field.extra.valores.forEach((value, index) => {
                let finalValue = value

                if (this.field.extra.tipo[index] !== undefined){
                    let valueField = value.replace(/@/g, '');

                    if (this.field.extra.tipo[index] === 'si'){
                        finalValue = this.formValues[valueField]
                    }else{
                        finalValue = this.getValueFromProcessData(valueField)
                    }
                }

                params.valores.push(finalValue)
            })

            return params
        },

        setApiAjaxResultToFormValues(){
            this.field.extra.get_value_campos.forEach((field, index) => {
                let realField = field.replace(/@/g, '')
                let apiAjaxValueField = this.field.extra.get_value_valores[index]

                if (this.proceduresStore.apiAjaxContent[apiAjaxValueField]){
                    this.formValues[realField] = this.proceduresStore.apiAjaxContent[apiAjaxValueField]
                }else{
                    this.formValues[realField] = ""
                }
            })
        },

        getValueFromProcessData(valueCode){
            let valueArray = valueCode.split('->')

            if (valueArray.length === 1){
                return this.procedureData[valueCode]
            }else if (valueArray.length === 2){
                return this.procedureData[valueArray[0]][valueArray[1]]
            }else if (valueArray.length === 3){
                return this.procedureData[valueArray[0][valueArray[1][valueArray[2]]]]
            }

            return ''
        },
        
        getUrl(originalUrl){
            if (originalUrl.includes('@@')) {
                let arrayUrl = originalUrl.split('/')
                if (arrayUrl.length > 0) {
                    let variableValue = this.getValueFromProcessData(arrayUrl[0].replace(/@/g, ''))

                    return  originalUrl.replace(arrayUrl[0], variableValue)
                }
            }

            return originalUrl
        }
    }

}
</script>

<style scoped>

</style>